define([
	"dojo/_base/declare",
	"csi/view/ToolbarPluginSwitchboard"
], function(declare,ToolbarPluginSwitchboard) {

	return declare(ToolbarPluginSwitchboard, {
		disableButtonAction: true,
		idViewProperty: "activeProductAlternative",
		placeHolder: "SelectOne",
		resDefault: "",
		switchboardPath: "Child:__Parent__/Child:__Parent__/Child:ProductAlternatives",

		_getStoreOptions: function(url, r) {
			const ctx = this.getView().getContext();
			const bomRev = ctx.getParent();
			const dataSheetContainerNode = ctx.getNodeParent(ctx.getNodeParent(bomRev));
			if (dataSheetContainerNode?.$Type === "ProductSource") {
				this.switchboardPath = "Child:__Parent__/Child:__Parent__/Child:__Parent__/Child:__Parent__/Child:ProductAlternatives";
			}

			return this.inherited(arguments);
		},

		canShowPlugin: function() {
			// summary: return true if there is at least one alternative
			const ctx = this.getView().getContext();
			const bomRev = ctx.getParent();
			const dataSheetContainerNode = ctx.getNodeParent(ctx.getNodeParent(bomRev));
			const productNode = dataSheetContainerNode?.$Type === "ProductSource" ? ctx.getNodeParent(ctx.getNodeParent(dataSheetContainerNode)) : dataSheetContainerNode;
			return productNode?.ProductAlternatives?.length > 0;
		},

		onChangeItem: function(/*csi.view.Widget*/view, /*Node*/node) {
			// summary: do nothing - idViewProperty handles it all
		},

		validatePlugin: function(/*Context*/ctx) {
			// summary: hide if printing
			return !ctx.bPrint;
		}
	});
});